import React from "react";

export default function Result() {
  return (
    <div className="box-content h-24">
      <p className="text-lg ...">
        Nice, you have more than 6 month of emergency saving!
      </p>
    </div>
  );
}
